import React, { useState, useEffect, useContext, useRef } from "react";
import "./Navbar.css";
import {
  FaBars,
  FaTimes,
  FaUser,
  FaSignOutAlt,
  FaUserCircle,
  FaSearch,
} from "react-icons/fa";
import nobelLogo from "../../assets/images/nobel_logo.png";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";

const Navbar = React.forwardRef(({ isTemplate, showLogo = true }, ref) => {
  const { user, logout } = useContext(UserContext);
  console.log("uu", user);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef();
  const navigate = useNavigate();

  // toggle scrolled state
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isDrawerOpen ? "hidden" : "auto";
  }, [isDrawerOpen]);

  // auto-close drawer if viewport grows above mobile width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && isDrawerOpen) {
        setIsDrawerOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isDrawerOpen]);

  const handleDrawerToggle = () => {
    setIsDrawerOpen((open) => !open);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <>
      <nav
        className={`navbar ${isScrolled ? "scrolled" : ""}`}
        style={{ backgroundColor: !showLogo ? "#020281" : "#05151c" }}
        ref={ref}
      >
        {showLogo ? (
          <div className="navbar-logo">
            <img src={nobelLogo} alt="Nobel AI Legal" className="nav-logo" />
          </div>
        ) : (
          <div className="navbar-header-logo2">
            <span className="navbar-text-logo">NobelAI Legal</span>
          </div>
        )}

        <div className="navbar-links">
          {isTemplate && user ? (
            <>
              <div className="navbar-search-container">
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search..."
                />
                <button className="search-button">
                  <FaSearch />
                </button>
              </div>

              <div className="user-dropdown-container" ref={dropdownRef}>
                <div className="nav-user-wrapper" onClick={toggleDropdown}>
                  <span className="nav-user-name">Hi, {user.full_name}</span>
                  <FaUser className="user-icon clickable" />
                </div>

                {isDropdownOpen && user && (
                  <div className="user-dropdown">
                    <p className="dropdown-hello">Hello, {user.full_name}</p>
                    <button
                      className="dropdown-item"
                      onClick={() => navigate("/profile")}
                    >
                      <FaUserCircle /> View Profile
                    </button>
                    <button className="dropdown-item" onClick={handleLogout}>
                      <FaSignOutAlt /> Logout
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/solutions">Solutions</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
              <li className="user-dropdown-container" ref={dropdownRef}>
                <a href="/login" className="nav-login-btn">
                  Login
                </a>
              </li>
            </ul>
          )}
        </div>

        <div className="menu-container">
          <button onClick={handleDrawerToggle} className="menu-button">
            {isDrawerOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </nav>

      {isDrawerOpen && (
        <div className="drawer">
          <button onClick={handleDrawerToggle} className="close-button">
            <FaTimes />
          </button>
          <ul className="drawer-list">
            <li>
              <a href="/" onClick={handleDrawerToggle}>
                Home
              </a>
            </li>
            <li>
              <a href="/about" onClick={handleDrawerToggle}>
                About Us
              </a>
            </li>
            <li>
              <a href="/solutions" onClick={handleDrawerToggle}>
                Solutions
              </a>
            </li>
            <li>
              <a href="/contact" onClick={handleDrawerToggle}>
                Contact
              </a>
            </li>
            <li>
              {isTemplate && user ? (
                <span className="nav-login-info" onClick={handleDrawerToggle}>
                  Hi{user.full_name ? `, ${user.full_name}` : ""}
                  <FaUser className="user-icon" />
                </span>
              ) : (
                <a
                  href="/login"
                  className="nav-login-btn"
                  onClick={handleDrawerToggle}
                >
                  Login
                </a>
              )}
            </li>
          </ul>
        </div>
      )}
    </>
  );
});

export default Navbar;
